<template>
    <ContentOrLoading>
        <div v-if="!loading">
            <div v-if="!zonaSeleccionada" :class="esMovil ? 'text-center' : ''">
                <div class="col-12 text-center">                                        
                    <CleSvgComponent 
                        v-if="zonas.length > 0"
                        :zonas="zonas" 
                        :place="place"
                        @clickZona="irAZona"
                    />
                </div>
            </div>
            <div v-else id="plano">
                <PorPlanoAbonos
                    :svg="svg"
                    :butacasFiltered="butacasFiltered"
                    :tipos="tipos"
                    :esMovil="esMovil"
                    @getButacas="getButacas"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import PorPlanoAbonos from './PorPlanoAbonos.vue';
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';

    export default {
        props: {
            tipos: {
                type: Object,
                required: true
            },
            unSelectZonaItem: {
                type: Number,
                required: true
            },
            esMovil: {
                type: Boolean
            }
        },
        data() {
            return {
                zonas: [],
                zonaSeleccionada: null,
                loading: false,
                butacas: [],
                svg: null,
                butacasFiltered: [],
            }
        },
        watch: {
            unSelectZonaItem() {
                this.zonaSeleccionada = null;
            }
        },
        methods: {
            irAZona(paso, zona) {
                this.zonaSeleccionada = zona;
                this.$emit('zonaIsSelected');
                this.getButacas();
            },
            getButacas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.$store.getters.getListaId,
                    place_id: this.place.id,
                    region_id: this.zonaSeleccionada.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonos.butacas.recintos-anexos.index'), params).then(res => {
                    this.butacas = res.data.data;
                    this.butacasFiltered = this.butacas.filter(butaca => butaca.svg_id);
                    this.getSvg();
                }).catch(() => {
                    console.warn('Error al recuperar las butacas en la configuración de precios de abonos');
                });
            },
            getRegionesAnexas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: this.place.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.regiones-anexas'), params).then(res => {
                    this.zonas = res.data.data;
                    this.loading = false;
                }).catch(() => {
                    console.warn('Error al recuperar las regiones anexas en la configuración de precios de abonos');
                });
            },
            getSvg() {
                const params = {
                    filters: {},
                    recinto_id: this.place.id,
                    region_id: this.zonaSeleccionada.id
                }

                this.$store.dispatch(this.config.getVuexAlias('recinto.zona-svg'), params).then(res => {
                    this.svg = res.data.svg;
                }).catch(() => {
                    console.warn('Error al recuperar el svg en la configuración de precios de abonos');
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        created() {
            this.getRegionesAnexas();
        },
        components: { PorPlanoAbonos, CleSvgComponent }
    }
</script>
